import React, { useCallback, useRef, useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

import {
  AsyncTableInfinite,
  ConfirmationModal,
  Intl,
  /* LocalTable, */
} from "components";
import { formatNumeral } from "utils";
import classnames from "classnames";

const hiddenIsLoading = true;

export default ({
  participants,
  participantsLoading,
  isLoading,
  parentPath,
  onFetchParticipants,
/*  onFetchparticipantOwnerData, */
  onDelete,
  userData,
}) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const idToDelete = useRef(null);

  const toggleDeleteModal = useCallback((id) => {
    idToDelete.current = id;
    setDeleteModal( ( state ) => !state );
  }, [] );

  const onFetchData = useCallback( () => {}, [] );
  return (
    <Container
      fluid
      className={classnames({
        "app-component-loading": participantsLoading,
      })}
    >
      <Row className="mb-2">
        <Col>
          <Intl id="administrator" />
        </Col>
      </Row>

      <Row>
        <Col>
          <AsyncTableInfinite
            data={participants && participants.userOwner ? [participants.userOwner] : []}
            isLoading={isLoading}
            hiddenIsLoading={hiddenIsLoading}
            total={participants && participants.total ? participants.total : 0}
            // onFetchparticipantOwnerData={onFetchparticipantOwnerData}
            onFetchData={onFetchData}
            defaultSortBy={[{ id: 'id', desc: true }]}
            minRows={1}
            tableName="admins"
            columns={[
              {
                Header: 'nameOrId',
                accessor: 'firstName',
                disableSorting: true,
                Cell: ( { cell } ) => `${cell.value || ''} ${cell.row.original.lastName || ''}`,
              },
              {
                Header: 'user',
                accessor: 'email',
                disableSorting: true,
              },
              {
                Header: 'sender',
                accessor: 'phone',
                disableSorting: true
              },
              {
                Header: 'creditCurrency',
                accessor: 'credit',
                disableSorting: true,
                style: { backgroundColor: '#FCEADA' },
                Cell: ( { cell } ) => formatNumeral( cell.value ),
              },
              {
                accessor: 'id',
                disableSorting: true,
                customWidth: 190,
                Header: '',
                Cell: ( { cell } ) => (
                  <>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to="/out/administration/buy-credit"
                    >
                      <Intl id="credit" />
                    </Button>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to={`${parentPath}/edit/${cell.value}`}
                    >
                      <Intl id="edit" />
                    </Button>
                  </>
                ),
              },
            ]}
            headerWidth={['col-2', 'col-4', 'col', 'col-1-3qtr', 'col']}
            values={{ currency: "(" + userData.currency_symbol + ")" }}
          />
          {/* <LocalTable
            data={participants && participants.userOwner ? [participants.userOwner] : []}
             manualPagination
            onlyTable
            columns={[
              {
                Header: "nameOrId",
                accessor: "firstName",
                disableSorting: true,
                Cell: ({ cell }) =>
                  `${cell.value || ""} ${cell.row.original.lastName || ""}`,
              },
              {
                Header: "user",
                accessor: "email",
                disableSorting: true,
              },
              {
                Header: "sender",
                accessor: "phone",
                disableSorting: true,
              },
              {
                Header: "creditCurrency",
                accessor: "credit",
                disableSorting: true,
                style: { backgroundColor: "#FCEADA" },
                Cell: ({ cell }) => formatNumeral(cell.value),
              },
              {
                accessor: "id",
                disableSorting: true,
                customWidth: 190,
                Header: "",
                Cell: ({ cell }) => (
                  <>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to="/out/administration/buy-credit"
                    >
                      <Intl id="credit" />
                    </Button>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to={`${parentPath}/edit/${cell.value}`}
                    >
                      <Intl id="edit" />
                    </Button>
                  </>
                ),
              },
            ]}
          /> */}
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <AsyncTableInfinite
            data={participants.data}
            isLoading={participantsLoading}
            hiddenIsLoading={hiddenIsLoading}
            total={participants.total}
            onFetchData={onFetchParticipants}
            titleContent={<Intl id="users" />}
            defaultSortBy={[{ id: "createdAt", desc: true }]}
            tableName="subusers"
            rightContent={
              <Link
                to={`${parentPath}/new`}
                className="btn-app-default btn-app-sm"
              >
                <Intl id="newUser" />
              </Link>
            }
            columns={[
              {
                Header: "nameOrId",
                accessor: "firstName",
                Cell: ({ cell }) =>
                  `${cell.value || ""} ${cell.row.original.lastName || ""}`,
                width: 18.5,
              },
              {
                Header: "user",
                accessor: "email",
                width: 29.7,
              },
              {
                Header: "sender",
                accessor: "phone",
                width: 17.8,
              },
              {
                Header: "creditCurrency",
                accessor: "credit",
                style: { backgroundColor: "#FCEADA" },
                Cell: ({ cell }) => formatNumeral(cell.value),
                width: 14.7,
              },
              {
                accessor: "id",
                disableSorting: true,
                customWidth: 190,
                Header: "",
                Cell: ({ cell }) => (
                  <>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to={`${parentPath}/credit/${cell.value}`}
                    >
                      <Intl id="credit" />
                    </Button>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      tag={Link}
                      to={`${parentPath}/edit/${cell.value}`}
                    >
                      <Intl id="edit" />
                    </Button>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      onClick={() => {
                        toggleDeleteModal(cell.value);
                      }}
                    >
                      <Intl id="delete" />
                    </Button>
                  </>
                ),
              },
            ]}
            values={{ currency: "(" + userData.currency_symbol + ")" }}
            headerWidth={['col-2', 'col-4', 'col', 'col-1-3qtr', 'col']}
            minHeight
           />
        </Col>
      </Row>

      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          title="deleteModalUser.confirmation"
          onConfirm={() => onDelete(idToDelete.current, toggleDeleteModal)}
          onClose={toggleDeleteModal}
        />
      )}
    </Container>
  );
};
